//TODO support no network avilable request/role when to shoot event
//TODO delete from cache when need to be cleared/clean from localStorage after refresh of page, meaning get the request again after initiliaztion
//TODO cache, will be clear GET information from POST/PUT(update) requests ?
//TODO flag if promise was resolved, then method to register callbacks

var _alternativeStorage = function(){
    this.storage = {};
    this.setItem = function(key, value) {this.storage[key] = value;};
    this.getItem = function(key) {return this.storage[key];};
    this.removeItem = function(key) {delete this.storage[key];};
};



//Check if localstorage avilable

var hasStorage = (function() {
    try {
        if(typeof localStorage != 'undefined') {
            localStorage.setItem("foo", "bar");
            localStorage.removeItem("foo");
            return true;
        } else {
            return false;
        }
    } catch (exception) {
        return false;
    }
}());

var NetworkManager = {
//	mapping: {},
    Actions: {
        "ALWAYS": "ALWAYS",
        "RELOAD": "RELOAD",
        "NEVER" : "NEVER"
    },
    initialized: false,
    storage: (hasStorage) ? localStorage : new _alternativeStorage(),
    retries: 3,
    listeners: {},

    init: function(options) {
        if (!Date.now) {
            this.now = function() { return new Date().getTime(); }
        } else {
            this.now = Date.now;
        }

        this.initTime = this.now();

        if(options) {
            //if(options.hasOwnProperty('mapping')) {
            //	this.mapping = options.mapping;
            //}

            if(options.hasOwnProperty('retries')) {
                if(parseInt(options.retries) == NaN) {
                    console.error('Retries must be a number');
                } else {
                    this.retries = options.retries;
                }
            }

            if(options.hasOwnProperty('csrfToken')) {
                this.csrfToken = options.csrfToken;
            }

            if(options.hasOwnProperty('baseUrl')) {
                this.baseUrl = options.baseUrl + (options.baseUrl.substr(-1) == '/' ? '' : '/');
            }
            else
                this.baseUrl = '';
        }

        this._storeMSXMLVersion();

        this.initialized = true;
    },

    addNetworkListener: function(id, listener) {
        this.listeners[id] = listener;
    },

    removeNetworkListener: function(id) {
        delete this.listeners[id];
    },

    _fireNetworkEvent: function(event, values) {
        for (var key in this.listeners) {
            var l = this.listeners[key];
            if(l.hasOwnProperty(event)) {
                l[event].apply(this, values);
            }
        }
    },

    action: function(action, urlParams, requestParams, success, error) {
        if(!this.initialized) {console.error('Network manager must be initialized');}


        var promise = {};
        if(action.response_array) {
            promise = [];
        }

        var storedValue = this._getStoredValue(action, urlParams, requestParams);

        if(storedValue) {
            promise.$promise = new Promise(function(resolve, reject) {
                var response = storedValue;
                try {
                    response = JSON.parse(storedValue);
                } catch (e) {}

                this._shallowClearAndCopy(response, promise);
                resolve(response);
            }.bind(this));
        } else {
            promise.$promise = new Promise(function(resolve, reject) {
                this._send(promise, action, urlParams || {}, requestParams || {}, resolve, reject);
            }.bind(this));
        }

        promise.$promise.catch(error || function() {});

        if(success || error) {
            promise.$promise.then(success || function() {}).catch(error || function() {});
        }

        return promise;
    },

    _send: function(promise, action, urlParams, requestParams, success, error) {
        var url = this._buildUrl(action.url, urlParams);

        var retries = action.hasOwnProperty('retries') ? action.retries : this.retries;

        //FIRE NETWORK EVENT
        this._fireNetworkEvent('onNetworkStart', [url, action.label]);

        var self = this;

        this._ajax({
            tryCount: 0,
            retryLimit: retries,
            finished: false,
            method: action.method,
            url: url,
            data: requestParams,
            success: function(data) {
                self._storeValue(action, urlParams, requestParams, data.response);

                //Check if not json return string
                var response = data.response;
                try {
                    response = JSON.parse(data.response);
                } catch (e) {}

                self._shallowClearAndCopy(response, promise);
                success(response);

                //FIRE NETWORK EVENT
                self._fireNetworkEvent('onNetworkSuccess', [url, this.tryCount, action.label]);
            },
            error: function(xhr, ajaxOptions, thrownError) {
                this.tryCount++;
                if (this.tryCount < this.retryLimit) {
                    //TRY AGAIN
                    self._ajax(this);
                } else {
                    this.finished = true;

                    error(xhr);
                    //FIRE NETWORK EVENT
                    self._fireNetworkEvent('onNetworkError', [url, this.tryCount, action.label, xhr.status]);

                    if(xhr.status == 401) {
                        //FIRE NETWORK EVENT
                        self._fireNetworkEvent('onNetworkUnauthorized', [url, this.tryCount, action.label]);
                    }
                }
            }
        });

    },

    lastActiveXSupported: undefined,

    _storeMSXMLVersion: function() {
        if(typeof XMLHttpRequest !== 'undefined') {
            this.lastActiveXSupported = undefined
        } else {
            var versions = ["MSXML2.XmlHttp.5.0",
                "MSXML2.XmlHttp.4.0",
                "MSXML2.XmlHttp.3.0",
                "MSXML2.XmlHttp.2.0",
                "Microsoft.XmlHttp"];
            for(var i = 0, len = versions.length; i < len; i++) {
                try {
                    xhr = new ActiveXObject(versions[i]);
                    this.lastActiveXSupported = versions[i];
                    break;
                }catch(e){}
            }
        }
    },
    _ajax: function(options) {
        var xhr;

        if(typeof XMLHttpRequest !== 'undefined') {
            xhr = new XMLHttpRequest();
        } else {
            xhr = new ActiveXObject(this.lastActiveXSupported);
        }

        function ensureReadiness() {
            if(xhr.readyState < 4) {
                return;
            }

            if(xhr.readyState === 4) {
                var isSuccess = xhr.status >= 200 && xhr.status < 300 || xhr.status === 304;

                if(isSuccess) {
                    options.success(xhr);
                } else {
                    options.error(xhr);
                }
            }
        }
        xhr.onreadystatechange = ensureReadiness;

        var hasData = options.data != undefined;

        xhr.open(options.method, options.url, true);

        xhr.setRequestHeader("Accept", "application/json");

        if(hasData) {
            xhr.setRequestHeader("Content-type", "application/json;charset=UTF-8");
        }

        if(this.csrfToken) {
            xhr.setRequestHeader("X-CSRFToken", this.csrfToken);
        }

        xhr.send(( hasData && JSON.stringify(options.data) ) || null);
    },

    _storeValue: function(action, urlParams, requestParams, data) {
        if(this._isStoreAction(action)) {
            var key = this._buildStoreSignature(action, urlParams, requestParams);
            var value = { time: this.now(), data: data };
            this.storage.setItem(key, JSON.stringify(value));
        }
    },
    _getStoredValue: function(action, urlParams, requestParams) {
        if(this._isStoreAction(action)) {
            var key = this._buildStoreSignature(action, urlParams, requestParams);
            var storedString = this.storage.getItem(key);
            if(storedString) {
                var storedValue = JSON.parse(storedString);
                if(action.expires == this.Actions.NEVER) {
                    return storedValue.data;
                }

                if(action.expires == this.Actions.RELOAD) {
                    if(this.initTime > storedValue.time) {
                        this.storage.removeItem(key);
                        return undefined;
                    } else {
                        return storedValue.data;
                    }
                }

                var expiresSec = parseInt(action.expires);
                if(!isNaN(expiresSec)) {
                    if(storedValue.time + (expiresSec * 1000) < this.now()) {
                        return storedValue.data;
                    } else {
                        this.storage.removeItem(key);
                    }
                }
            }
        }
        return undefined;
    },

    _isStoreAction: function(action) {
        return (action.hasOwnProperty('expires') && action.expires != this.Actions.ALWAYS);
    },

    _buildStoreSignature: function(action, urlParams, requestParams) {
        //Create a unique key by method, url, urlParams, requestParams
        var result = action.method + '-' + action.url;
        result += "-U-";
        for(var prop in urlParams) {
            result += urlParams[prop] + "-";
        }
        result += "-R-";
        for(var prop in urlParams) {
            result += urlParams[prop] + "-";
        }
        return result;
    },

    _buildUrl: function(url, urlParams) {
        url = this.baseUrl + url;
        var result = url.split("?")[0]; // remove ? and the trailing becuase this will be overwritten
        var queryString = "";

        for (var prop in urlParams) {
            if (result.indexOf(":" + prop) !== -1) {
                result = result.replace(":" + prop, encodeURIComponent(urlParams[prop]));
            } else {
                queryString += (queryString == "" ? "?" : "&") + prop + "=" + encodeURIComponent(urlParams[prop]);
            }
        }

        result = result + queryString;

        return result;
    },

    _shallowClearAndCopy: function(src, dst) {
        dst = dst || {};

        //Remove old props like the update method
        for(var key in dst) {
            delete dst[key];
        }

        //Copy new ones
        for (var key in src) {
            if (src.hasOwnProperty(key)) {
                dst[key] = src[key];
            }
        }

        return dst;
    },

    setStorage: function(storage){
        // validate localStorage api
        var requiredMethods = ['setItem', 'getItem', 'removeItem'];
        for(var i=0; i<requiredMethods.length; i++){
            var methodName = requiredMethods[i];
            if(typeof storage[methodName] !== 'function'){
                console.error('Network Manager storage requires ' + methodName + ' method to be implemented');
                return;
            }
        }

        this.storage = storage;
        console.log('Network Manager has set a custom storage');
    },


    _validFileName: function (name) {
        return /^[A-Za-z][A-Za-z0-9]*$/.test(name);
    },


    upload: function(url, file, progressEventCallback) {
        var xhr = new XMLHttpRequest(),
            method = 'POST',
            promise = {};

        if (!xhr.upload || !FormData) {
            promise.$promise = new Promise(function(resolve, reject) {
                reject('File uploading is not supported');
            });

            return promise;
        }

        xhr.upload.addEventListener('progress', function(e) {
            var progress = (e.loaded / e.total * 100);
            progressEventCallback(progress,file);
        }, false);

        promise.$promise = new Promise(function(resolve, reject) {

            // Response
            xhr.onreadystatechange = function(e) {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    var isSuccess = xhr.status >= 200 && xhr.status < 300 || xhr.status === 304;
                    if (isSuccess) {
                        resolve(xhr.responseText);
                    } else {
                        reject(xhr.responseText);
                    }
                }
            };

            // Send request
            var data = new FormData();
            data.append('file', file);

            xhr.open(method, url, true);
            if (this._validFileName(file.name)) {
                xhr.setRequestHeader('X-FILENAME', file.name);
            }

            if (typeof csrfToken != 'undefined') {
                xhr.setRequestHeader("X-CSRFToken", csrfToken);
            }

            xhr.send(data);

        }.bind(this));

        return promise;
    }


};


module.exports = NetworkManager;


//////////////////
// WEBPACK FOOTER
// ./node_modules/network-manager/src/NetworkManager.js
// module id = 27
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30